export type AgrupamentoKanban = 'status' | 'pendencia' | 'customizado';

export const AGRUPAMENTO_KANBAN_LABELS: Record<AgrupamentoKanban, string> = {
  status: 'Por Status',
  pendencia: 'Por Pendência',
  customizado: 'Personalizado',
};

/** Uma coluna do modo "Personalizado" — o usuário escolhe livremente entre valores de
 * status, alerta ou pendência (podem se misturar na mesma view). Uma Solicitação pode
 * aparecer em mais de uma coluna (ex.: status "Novo" e, ao mesmo tempo, um alerta
 * específico) — não é uma partição estrita como o modo "Por Status". */
export interface ColunaCustomizada {
  tipo: 'status' | 'alerta' | 'pendencia';
  valor: string;
  label: string;
}
